export type QueryParams<T> = Partial<{ [P in keyof T]: T[P] }>;

const useQueryParams = <T>(): QueryParams<T> => {
  const urlParams = new URLSearchParams(window.location.search);
  return Array.from(new URLSearchParams(window.location.search).entries()).reduce((prev, [key]) => {
    let keyValue: any = urlParams.get(key);
    if (key.endsWith('[]')) {
      keyValue = urlParams.getAll(key);
    }
    return {
      ...prev,
      [`${key.replace('[]', '')}`]: keyValue,
    };
  }, {});
};

export default useQueryParams;
